<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL of TECHNOLOGY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Civil Engineering</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                            <th class="time">Post Graduate</th>
                            <th class="time">Doctorate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time text-nowrap">Bachelor of Technology (Civil Engineering)</td>
                            <td class="time text-nowrap">Master of Technology (Civil Engineering)</td>
                            <td class="time text-nowrap">Ph.D Civil</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Civil Engineering</h5>
        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Technology (Civil Engineering) </b> —
                    ARNI School of Technology
                    offers a B.Tech in Civil Engineering to
                    prepare future engineers with the required skills and knowledge. The program equips students to
                    address
                    real-world challenges in infrastructure development. There are eight semesters in this four-year
                    degree
                    program.
                </p>
            </div>
            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester I</b> : Foundation</p>
                <ul>
                    <li>Engineering Physics/Chemistry/Mathematics - I</li>
                    <li>Differential Equations and Linear Algebra</li>
                    <li>Basics of Civil Engineering</li>
                    <li>Environmental Science</li>
                    <li>Engineering Drawing & Graphics</li>
                    <li>Engineering Mechanics</li>
                </ul>
            </div>
            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester II</b> : Core Concepts</p>
                <ul>
                    <li>Engineering Physics/Chemistry/Mathematics - II</li>
                    <li>Transform Calculus and Numerical Analysis</li>
                    <li>Building Materials and Construction Techniques</li>
                    <li>Strength of Materials-I</li>
                    <li>Basics Electronics</li>
                    <li>HASS Elective I</li>
                </ul>
            </div>
            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester III</b> : Applications</p>
                <ul>
                    <li>Engineering Physics/Chemistry/Mathematics - III</li>
                    <li>Structural Analysis-I</li>
                    <li>Geotechnical Engineering-I</li>
                    <li>Construction Project Management</li>
                    <li>Fluid Mechanics</li>
                    <li>Scientific & Technical Writing</li>
                    <li>Building Drawing, Estimation & Costing</li>
                </ul>
            </div>
            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester IV</b> : Advanced Core</p>
                <ul>
                    <li> Structural Analysis-II</li>
                    <li>Geotechnical Engineering-II</li>
                    <li>Water Resources Engineering</li>
                    <li>Vectors, PDEs and Complex Analysis</li>
                    <li>Industry 4.0 Technologies</li>
                    <li>Soil Mechanics</li>
                    <li>Water Supply, Sewerage & Urban Drainage Design</li>
                    <li>HASS Elective II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester V</b> : Specializations Begins</p>
                <ul>
                    <li>Environmental Engineering</li>
                    <li>Engineering Economics</li>
                    <li>Engineering Foundation</li>
                    <li>Transportation Engineering</li>
                    <li>Engineering Geology</li>
                    <li>HASS Elective III</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VI</b> : Practical Applications</p>
                <ul>
                    <li>Design of Concrete Structures II</li>
                    <li>Design of Steel Structures I</li>
                    <li>Project Planning and Management</li>
                    <li>Computer-Aided Structural Design and Detailing</li>
                    <li>Professional Elective I</li>
                    <li>Open Elective I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VII
                </b> : Real-World Training</p>
                <ul>
                    <li>Professional Elective II</li>
                    <li>Open Elective II</li>
                    <li>Engineering Professional Practice</li>
                    <li>Internship and Training</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VIII
                </b> : Research</p>
                <ul>
                    <li>Advanced Structural Analysis</li>
                    <li>Professional Elective III</li>
                    <li>Open Elective III</li>
                    <li>Major Project/Thesis</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Technology (Civil Engineering)</b> – The
                    Master of Technology (M.Tech) in Civil Engineering
                    program offered by ARNI School of Technologies is designed to provide advanced skills and knowledge
                    for students and professionals aiming to deepen their expertise in civil engineering. This 2-year
                    degree divided into 4 semesters, contributes to nation-building.</p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-black text-decoration-underline">Semester I</b> : Foundational and Advanced Concepts
                </p>
                <ul>
                    <li>Construction Technology and Management</li>
                    <li>Advanced Mathematics for Engineers</li>
                    <li>Computational Methods in Civil Engineering</li>
                    <li>Contract Management & Quantity Surveying</li>
                    <li>Infrastructure Management</li>
                    <li>Elective I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-black text-decoration-underline">Semester II
                </b> : Specialized Studies</p>
                <ul>
                    <li>Advanced Design of Concrete Structures
                    </li>
                    <li>Advanced Construction Materials
                    </li>
                    <li> Soft Computing Techniques in Civil Engineering
                    </li>
                    <li>Construction Equipment and Methods
                    </li>
                    <li>Project Management
                    </li>
                    <li>Elective II
                    </li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-black text-decoration-underline">Semester III
                </b> : Research and Applications
                </p>
                <ul>
                    <li>Thesis I</li>
                    <li>Seminar</li>
                    <li>Dissertation Phase-I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-black text-decoration-underline">Semester IV
                </b> : Advanced Core</p>
                <ul>
                    <li>Thesis II</li>
                    <li>Seminar and Viva Voce</li>
                    <li>Dissertation Phase-II</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-decoration-underline text-black">Ph.D Civil Engineering </b> – The Ph.D. in Civil
                    Engineering program at ARNI School of Technology is
                    designed for scholars passionate about advanced research and innovation in civil engineering. The
                    program provides thorough skills and knowledge to passionate individuals who can contribute to
                    academic excellence, sustainable development, and industrial advancements. The duration is 3-6 years
                    and divided into 6 semesters.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-black text-decoration-underline">Semester I</b> : Coursework</p>
                <ul>
                    <li>Finite Element Analysis</li>
                    <li>Foundations Of Research And Publication Ethics</li>
                    <li>Optimization Techniques</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-black text-decoration-underline">Semester II
                </b> : Practical</p>
                <ul>
                    <li>Advanced Wastewater Treatment</li>
                    <li>Research Design</li>
                    <li>Structural Dynamics</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-black text-decoration-underline">Semester III
                </b> : Specializations</p>
                <ul>
                    <li>Water Quality and Environment
                    </li>
                    <li>Hydrologic Elements and Analysis
                    </li>
                    <li>Sustainable Construction Materials and Methods
                    </li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-black text-decoration-underline">Semester IV
                </b> : Research and Development</p>
                <ul>
                    <li>  Geosynthetics
                    </li>
                    <li> Research Methodology
                    </li>
                    <li>Geotechnical Earthquake Engineering
                    </li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-black text-decoration-underline">Semester V
                </b> : Research and Dissertation</p>
                <ul>
                    <li>Research Project
                    </li>
                    <li>Dissertation
                    </li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-black text-decoration-underline">Semester VI

                </b> : Research and Dissertation</p>
                <ul>
                    <li>Research Project
                    </li>
                    <li>Dissertation
                    </li>
                </ul>
            </div>
        </div>


    </div>
</section>
